// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--3of78";
export var icon_box = "styles-module--icon_box--34VLm";